import React, { useEffect, useState } from 'react';
import {
  Container,
  Box,
  Typography,
  Button,
  CircularProgress,
  Alert,
} from '@mui/material';
import { useSearchParams } from 'react-router-dom';

import appLogo from "../../images/website-images/logos/app-logo.png";

import { confirmDoubleOptIn,resendDoubleOptInEmail } from "../../common/FunctionCalls";

export default function ConfirmMarketingOptIn() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading'); // loading | success | expired | error | resent
  const [emailResent, setEmailResent] = useState(false);


  let token = searchParams.get('token');
  token = decodeURIComponent(token);
  
  useEffect(() => {

    const confirmOptIn = async (token) => {
      try {
        const success = await confirmDoubleOptIn(token);

        if (success === true) {
          setStatus('success');
        } else {
          throw new Error('Invalid token');
        }
      } catch (error) {
        console.error(error);
        setStatus('expired');
      }
    };

    if (token) {
      confirmOptIn(token);
    } else {
      setStatus('error');
    }
  }, [token]);

  const handleResend = async () => {
    try {
      await resendDoubleOptInEmail(token);
      setEmailResent(true);
      setStatus('resent');
    } catch (error) {
      console.error(error);
      setStatus('error');
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 10 }}>

    <Box textAlign="center" pb={1}>
            <img
              src={appLogo}
              alt="App Logo"
              style={{ height: 85}}
            />
            <Typography component="h1" variant="h6" fontWeight="600" mt={2}>
              GoTailo®
            </Typography>
      </Box>
      
      <Box
        sx={{
          p: 4,
          borderRadius: 4,
          boxShadow: 3,
          bgcolor: '#fff',
          textAlign: 'center',
        }}
      >
        {status === 'loading' && (
          <>
            <CircularProgress />
            <Typography mt={2}>Confirming your opt-in preferences...</Typography>
          </>
        )}

        {status === 'success' && (
          <Alert severity="success">
            <Typography variant="h6" gutterBottom>
              You're subscribed! 🎉
            </Typography>
            <Typography>
              Thank you for confirming your opt-in. You'll now receive occasional updates and marketing emails from us. You can opt out at any time.
          </Typography>
          </Alert>
        )}

        {status === 'expired' && (
          <>
            <Alert severity="warning" sx={{ mb: 2 }}>
              <Typography variant="h6">Your confirmation link has expired.</Typography>
              <Typography variant="body2">
                For security reasons, email opt-in confirmation links expire after 72 hours. Click below to receive a new confirmation email.
              </Typography>
            </Alert>
            <Button
              variant="contained"
              color="primary"
              onClick={handleResend}
              disabled={emailResent}
            >
              {emailResent ? 'Email Sent ✔️' : 'Resend Confirmation Email'}
            </Button>
          </>
        )}

        {status === 'resent' && (
          <Alert severity="info" sx={{ mt: 2 }}>
            We've sent you a new opt-in confirmation email. Please check your inbox.
          </Alert>
        )}

        {status === 'error' && (
          <Alert severity="error">
            Something went wrong. Please check the link or contact support.
          </Alert>
        )}
      </Box>
    </Container>
  );
}
